// This template for the items inside of the Algolia list item
export const catalogRefinementItem = '<div class="flex w-full items-center cursor-pointer"><span class="hover:underline">{{label}}</span> <span class="ml-2 text-xs py-1 px-2 text-blue-400 border-solid border-blue-500 leading-none bg-blue-100 rounded-full">{{count}}</span></div>'

// classes for the wrapping li that's added by Algolia
// Note: additional styles, for functions such as active state, are in sass/_components.algolia.scss
export const catalogRefinementClasses = {
  root: 'MyCustomRefinementList',
  noRefinementRoot: 's-no-results',
  list: ['w-full'],
  item: ['mb-1 mx-0 flex text-sm'],
}
